export default [
  {
    path: "/pemotongan-hewan/",
    component: () =>
      import("@/pages/pemotongan-hewan/pemotongan-hewan-list.vue"),
    meta: { title: "Daftar Pemotongan Hewan" },
  },
  {
    path: "/pemotongan-hewan/create",
    component: () =>
      import("@/pages/pemotongan-hewan/pemotongan-hewan-form.vue"),
    meta: { title: "Tambah Pemotongan Hewan" },
  },
  {
    path: "/pemotongan-hewan/detail/:id",
    component: () =>
      import("@/pages/pemotongan-hewan/pemotongan-hewan-detail.vue"),
    meta: { title: "Detail Pemotongan Hewan" },
  },
  {
    path: "/pemotongan-hewan/update/:id",
    component: () =>
      import("@/pages/pemotongan-hewan/pemotongan-hewan-update.vue"),
    meta: { title: "Update Pemotongan Hewan" },
  },
];
